import { BasePage } from '@/components/ui/base-page'
import { DigitalFundsContent } from '@/components/shared'

export function DigitalFundsPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      <DigitalFundsContent />
    </BasePage>
  )
}